import useEffect from '../useEffect';
const MOCK_API = 'MOCK_API';
/**
 * This hook is used to prevent infinite loading on a page by
 * manipulating the apiProcessingPool and apiDonePool.
 * @param {object} param
 * @param {function} param.setApiProcessingPool - from 'useApiLoadingPool' hook
 * @param {function} param.setApiDonePool - from 'useApiLoadingPool' hook
 */
export function usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool, }) {
    // #NOTES
    // Currently, we prevent infinite loading(turn off loading) by updating the
    // apiProcessingPool and apiDonePool and forcing the useEffect inside 'useApiLoadingPool' to run.
    // #TODO
    // Implement a better solution to prevent infinite loading, e.g., store the timestamp of
    // each API call, and move the API from the apiProcessingPool to apiDonePool automatically
    // after a certain amount of time.
    useEffect(() => {
        setApiProcessingPool((prev) => [...prev, MOCK_API]);
        setApiDonePool((prev) => [...prev, MOCK_API]);
    }, []);
}
